import React from "react";

const Topbar = () => {
  return (
    <div className="px-3 py-1 bg-sec-700">
      <div className="container">
        <div className="flex items-center justify-center sm:justify-between text-white">
          <div className="hidden sm:block"></div>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <i className="ri-mail-line text-base text-pri-500"></i>

              <div>info@achauffeur.com</div>
            </div>
            <div className="hidden sm:flex items-center gap-2">
              <i className="ri-phone-line text-base text-pri-500"></i>
              <div>+1- 888-999-4545 &nbsp; | &nbsp; +1-416-800-1009</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
